import { useState } from "react";
import { BodyModal, BtnAplicarWrapper, BuscadorBox, Container, Line, Top } from "./localStyle";
import CheckBoxGroupFilter from "_+_Portal/components/Genericos/CheckBoxGroupFilter/CheckBoxGroupFilter";

const ModalEspecialistas = ({
  titulo,
  data,
  handleChangeCheckbox,
  setEspecialistasOriginal,
  dissmiss,
  categoria = "especialistas",
  placeholderBusqueda = "Buscar especialista...",
  labelBusqueda = "Especialista",
}) => {
  const [localData, setLocalData] = useState(data);
  const [searchTerm, setSearchTerm] = useState("");

  const setDataOriginal = setEspecialistasOriginal;

  const updateData = (groupKey, updatedGroup) => {
    const updatedData = localData.map((item) => {
      // Actualizar los ítems del grupo correspondiente
      const updatedItem = updatedGroup.find(
        (groupItem) => groupItem.id === item.id
      );
      return updatedItem || item; // Si el ítem pertenece al grupo, usar el actualizado
    });

    setLocalData(updatedData); // Actualizar el estado local (se aplica al hacer clic en APLICAR)
  };

  const aplicarFiltros = () => {
    setDataOriginal(localData);
    handleChangeCheckbox(categoria, localData);
    dissmiss();
  };

  const filteredData = localData.filter((item) =>
    item.descripcion.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Ordenar ítems por descripción alfabéticamente
  const sortedItems = [...filteredData].sort((a, b) =>
    a.descripcion.localeCompare(b.descripcion)
  );

  // Agrupar ítems por la primera letra de la descripción
  const groupedItems = sortedItems.reduce((groups, item) => {
    const firstLetter = item.descripcion[0].toUpperCase();
    if (!groups[firstLetter]) {
      groups[firstLetter] = [];
    }
    groups[firstLetter].push(item);
    return groups;
  }, {});

  return (
    <Container>
      <Top>
        <span>{titulo}</span>
        <div className="cruz" onClick={() => dissmiss()}>
          X
        </div>
      </Top>
      <BodyModal>
        <BuscadorBox>
          <p className="rb24t">{labelBusqueda}</p>
          <input
            type="text"
            className="buscadorEsp rb16m"
            placeholder={placeholderBusqueda}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </BuscadorBox>
        {Object.keys(groupedItems).map((letter, index) => (
          <div key={letter} className={"sectionStyles"}>
            {index !== 0 && <Line />}
            <h2 className={"letterStyles"}>{letter}</h2>
            <ul className={"ulStyles"}>
              <CheckBoxGroupFilter
                data={groupedItems[letter]}
                onChange={(updatedGroup) => updateData(letter, updatedGroup)}
                wrapFlex={true}
              />
            </ul>
          </div>
        ))}
        <BtnAplicarWrapper>
          <button
            type="button"
            className="btn-aplicar rb18m"
            onClick={aplicarFiltros}
          >
            APLICAR
          </button>
        </BtnAplicarWrapper>
      </BodyModal>
    </Container>
  );
};
export default ModalEspecialistas;
